import { defineComponent } from 'vue';
const DialogMixin = defineComponent({
  props: {
    modelValue: Boolean,
  },

  emits: ['update:modelValue'],

  computed: {
    showDialog: {
      get (): boolean {
        return this.modelValue;
      },
      set (value: boolean) {
        this.$emit('update:modelValue', value);
      }
    },
  },
})

export { DialogMixin }
